import Image from "next/image";
import styles from "./ulcer-management.module.scss";

export default function UlcerManagement() {
  return (
    <div className={`${styles["UlcerManagement"]}`}>
      <div className={`${styles["UlcerManagementContainer"]}`}>
        <div className={`${styles["UlcerManagementMiddle"]}`}>
          <div className={`${styles["UlcerManagementMiddleItem"]}`}>
            <Image
              src="/images/ulcer-management/globalpharma-25.png"
              alt="globalpharma"
              width={270}
              height={202}
              className={`${styles["UlcerManagementMiddleItemMainImage"]}`}
            />
            <a href="/en/ulcer-management-country/" rel="noopener">
              Patient Information leaflet / نشرة معلومات المريض
            </a>
            <a href="/en/ulcer-management-lang/" rel="noopener">
              Educational Content / محتوى تثقيفي
            </a>
          </div>
        </div>
      </div>
      <div className={`${styles["UlcerManagementBottom"]}`}>
        <p>
          POWERED BY{" "}
          <a href="https://www.qrhub.io" target="_blank" rel="noopener">
            <strong>QRHUB.IO</strong>{" "}
          </a>
          AND{" "}
          <a href="https://www.effective.ae" target="_blank" rel="noopener">
            <strong>EFFECTIVE AGENCY</strong>{" "}
          </a>
          COMPANY
        </p>
      </div>
    </div>
  );
}

UlcerManagement.hideLayout = true;
